export default __webpack_public_path__ + "static/Metal_Arrow-beea8a90938fc8194f51418a77f2b37c.png";